import React, { useEffect, useState } from "react";
import logoMembresia from "../../innerAsstes/membresia/membresia logo.png";
import membresia1 from "../../innerAsstes/membresia/membresia1.png";
import membresia2 from "../../innerAsstes/membresia/membresia2.png";
import membresia3 from "../../innerAsstes/membresia/membresia3.png";
import membresia4 from "../../innerAsstes/membresia/membresia4.png";
import { useAppContext } from "../../App";
import { Box, HStack, Image, Text, useTheme, VStack } from "@chakra-ui/react";
import ButtonMore from "../../components/buttonMore/buttonMore";
import ImageAndParagraph from "../../components/imageAndParagraph/imageAndParagraph";
import { CustomGrid } from "../../components/customGrid/customGrid";
import DiscountCard from "../../components/community/discountCard/discountCard";
import { getBenefits } from "../../utils/dataFetch";

export default function Community() {
  const { isMobile } = useAppContext();
  const [allBenefits, setAllBenefits] = useState([]);
  const theme = useTheme();
  const style = styles(theme, isMobile);

  useEffect(() =>{
    getBenefits().then(res => setAllBenefits(res));
  },[]);
  
  const FirstContainer = isMobile? VStack : HStack;
  return (
    <div style={style.container}>
      <FirstContainer
        display={"flex"}
        p={"5vh"}
        justifyContent={'center'}
        backgroundColor={theme.background.primary}
        align={"flex-start"}
        style={{
        paddingLeft: isMobile ? '4vw' : '10vw',
        paddingRight: isMobile ? '4vw' : '10vw',
  }}
      >
        <VStack width={isMobile? "100%" : "60%"} align={"flex-start"} spacing={4}>
          <Image ml={0} src={logoMembresia} />
          <Text
            as={"span"}
            width={isMobile? "100%":"70%"}
            fontSize={isMobile? "2rem":"2rem"}
            textAlign={"left"}
            lineHeight={1}
            className="sansation-bold"
            color={theme.color.text.primary}
          >
            Sólo con haber hecho alguno de nuestros cursos, ya sos parte de
            nuestra Membresía Comunidad Gestar.
          </Text>
          <ButtonMore
            buttonText="Conocé los múltiples beneficios"
            customStyles={{
              container: { width: isMobile? '70%':'35%', padding: "0.5rem", marginLeft: 0 },
              text: { fontSize: "1rem" }
            }}
            customActionsOnCLick={() => {
              const formSection = document.getElementById("beneficios");
              formSection.scrollIntoView({ behavior: "smooth" });
            }}
          />
        </VStack>
        <Image src={membresia1} />
      </FirstContainer>
      <ImageAndParagraph
        imgSrc={membresia2}
        titleFirst="¿Sabías que una vez que has realizado un curso,"
        titleSecond="todos los proximos cursos que hagas tienen un 50% DE DESCUENTO?"
        customStyles={style.firstImgAndText}
      />
      <div id="beneficios">
        <ImageAndParagraph
          imgSrc={membresia3}
          titleFirst="BENEFICIOS"
          customStyles={style.secondImgAndText}
        />
        <CustomGrid items={allBenefits} iteratedComponent={DiscountCard}/>
      </div>
      <ImageAndParagraph 
        imgSrc={membresia4}
        titleFirst="Programa de"
        titleSecond="IMPULSO PROFESIONAL"
        fontFamilyDescription='quicksand-semibold'
        description="Porque además de acompañar tu formación y
            profesionalización, estamos súper comprometidos
            con tu desarrollo laboral."
        customStyles={style.thirdImgAndText}
      />
      <Box
        width={isMobile? "90%":'75%'}
        alignSelf={'center'}
      >
        <Text
          pl={'5vw'}
          pr={'5vw'}
          fontSize={isMobile? "1rem":'2rem'}
          textAlign={'center'} 
          lineHeight={1.2}
          bgColor={theme.background.tertiary} 
          color={theme.color.text.primary}
          className="quicksand-semibold"   
        >
          Inscribite sin cargo a los siguientes cursos y hacerlos a tus tiempos:
        </Text>
        <div style={style.nextCoursesRow} className="sansation-bold">
          <Text style={style.textStep}>Despegá tu carrera</Text>
          <Text style={style.textStep}>Optimizá tu tiempo</Text>
          <Text style={style.textStep}>Técnicas de estudio</Text>
          <Text style={{...style.textStep, borderRightWidth: 0}}>Introducción a Linkedin</Text>
        </div>
      </Box>
    </div>
  );
}
const styles = (theme, isMobile) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent:'center',
  },
  firstImgAndText:{
    container: {
      paddingLeft: isMobile ? '4vw' : '10vw',
      paddingRight: isMobile ? '4vw' : '10vw',
      paddingTop: 0,
      paddingBottom: 0,
      flexDirection: isMobile? "column":"row-reverse",
      justifyContent: "space-around",
    },
    textContainer: {
      padding: isMobile? '1.5rem':0,
      width: isMobile? "100%":"45%",
      alignContent: "center",
    },
    title1: {
      color: theme.color.text.tertiary,
      lineHeight: 1.2,
      fontSize: isMobile? "1.6rem" : "2rem",
      justifySelf: "center",
    },
    title2: {
      color: theme.color.text.secondary,
      lineHeight: 1.2,
      fontSize: isMobile? "1.6rem" : "2rem",
    },
  },
  secondImgAndText:{
    container: {
      paddingLeft: isMobile ? '4vw' : '10vw',
      paddingRight: isMobile ? '4vw' : '10vw',
      flexDirection: "row-reverse",
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.background.primary
    },
    textContainer:{
      justifyContent: 'center',
    },
    title1:{
      fontSize: isMobile? "1.5rem":"4rem",
      // justifySelf: 'center',
    },
    img:{
      width: '35%',
    }
  },
  thirdImgAndText:{
    container:{
      paddingLeft: isMobile ? '4vw' : '10vw',
      paddingRight: isMobile ? '4vw' : '10vw',
      paddingTop: '2%',
      paddingBottom: '2%',
      alignItems: 'center',
    },
    img: {
      padding: isMobile? 10 : 0,
      width: isMobile? '90%':'20%',
    },
    textContainer: {
      width: isMobile? '95%':'55%',
    },
    title1:{
      fontSize: isMobile? "1rem":"2rem",
      lineHeight: 1.2,
      color: theme.color.text.secondary
    },
    title2:{
      fontSize: isMobile? "1.5rem":"3rem",
      lineHeight: 1.2,
      color: theme.color.text.secondary
    },
    description:{
      fontSize: isMobile? "1.2rem":'1.5rem',
      lineHeight: 1.2,
      color: theme.color.text.tertiary,
    }
  },
  nextCoursesRow:{
    display: 'flex',
    flexDirection: isMobile? "column":'row',
    paddingTop: '2%',
    paddingBottom: '4%'
  },
  textStep:{
    fontSize: isMobile? "1.5rem":'1rem',
    paddingLeft: isMobile? 0 : '3rem',
    paddingRight: isMobile? 0 :'3rem',
    lineHeight: 1.2,
    borderRight: '1px solid',
    borderBottom: '1px solid',
    color: theme.color.text.secondary,
    borderRightColor: isMobile? "transparent": theme.color.text.tertiary,
    borderBottomColor: isMobile? theme.color.text.tertiary : "transparent",
  }
});
